import { colors } from '../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  profileSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 32,
  },
  btnBack: {
    border: 'none',
    backgroundColor: `${colors.primary100}`,
    width: '44px !important',
    height: '44px',
    minWidth: '44px !important',
    padding: '12px',
    borderRadius: '8px',
  },
});

export const sxStyles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    height: 80,
    padding: '16px',
  },
  outlineBtn: {
    borderColor: `${colors.primary300} !important`,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    padding: '40px',
  },
};
